import React, { Component } from 'react';
import _chunk from 'lodash.chunk';

import JobApplication from './components/JobApplication';

import './JobApplications.scss';

class JobApplications extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    console.log(this.props);
    return (
      <div className='job-applications'>
        <div className='container'>
          <div className='row'>
            <div className='col text-center'>
              <h3>Job Applications</h3>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              {_chunk(this.props['student-report-data'].positions, 3).map((row, rowIndex) => (
                <div className='row' key={rowIndex}>
                  {row.map((entry, entryIndex) => (
                    <div className='col-md-4' key={entry.id}>
                      <JobApplication job-application-data={entry} />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default JobApplications;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/JobApplications/index.js